import { render } from "./ThemeSwitcher.vue?vue&type=template&id=0665bf6a"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/shared/ThemeSwitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0665bf6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0665bf6a', __exports__)) {
    api.reload('0665bf6a', __exports__)
  }
  
  module.hot.accept("./ThemeSwitcher.vue?vue&type=template&id=0665bf6a", () => {
    api.rerender('0665bf6a', render)
  })

}


export default __exports__